import {Typography} from 'nf-ui'
import React, {FC} from 'react'

export const NotFound: FC = () => {
    return <Typography.Heading>404 Page (TODO)</Typography.Heading>
}
